import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomBadge, {atomBadgeDesigns, atomBadgeSizes, atomBadgeTypes} from '@s-ui/react-atom-badge'
import {atomIconSizes} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import IconStarFull from '@adv-mt/mt-svg-icons/lib/StarFull'

const RATING_BAGE_STAR_ICON_ID_PREFIX = 'mt-rating-badge-star-icon'

const RatingBadge = ({id, value}) => {
  const {i18n} = useContext(Context)

  return (
    <div className="mt-RatingBadge">
      <AtomBadge
        design={atomBadgeDesigns.SOFT}
        icon={
          <div className="mt-RatingBadge-iconRatingStar">
            <IconStarFull
              color="currentColor"
              id={`${RATING_BAGE_STAR_ICON_ID_PREFIX}-${id}`}
              size={atomIconSizes.extraSmall}
              title={i18n.t('COMMON.PLURALS.STAR', value)}
            />
          </div>
        }
        iconRight
        label={`${i18n.t('COMMON_PROFESSIONAL')} ${value}`}
        size={atomBadgeSizes.MEDIUM}
        type={atomBadgeTypes.INFO}
      />
    </div>
  )
}

RatingBadge.displayName = 'RatingBadge'
RatingBadge.propTypes = {
  id: PropTypes.string,
  value: PropTypes.number.isRequired
}

export default RatingBadge
